
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/adfs-alternative",
      function () {
        return require("private-next-pages/compare/adfs-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/adfs-alternative"])
      });
    }
  